/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate user types in the overall application.
   Developer: Aashish Singh, Created Date: 07-Aug-2025 
</summary>
*/
enum inventorySalePurchaseEnum{
    All = 0,
    Sale = 1,
    Purchased = 2,
    SalePurchase = 3,
}

export default inventorySalePurchaseEnum;